"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFERROR = void 0;
exports.IFERROR = {
    alias: 'SEERRO',
    description: 'pode ser usado para checar se um dado campo possui erro, e escolher um valor caso possua, e outro caso contrário',
    arg_names: ['campo', 'retorno_se_erro', 'retorno_se_não_erro'],
    args_description: [
        'campo que pode ter um erro',
        'retorno caso tenha erro',
        'retorno caso não tenha erro',
    ],
    replacements: [
        {
            TRUE: 'VERDADEIRO',
            FALSE: 'FALSO',
        },
        null,
        null,
    ],
};
